import { createContext } from "react";

import type { AgenticAiRuntimeContextType } from "./types";

export const initialAgenticAiRuntimeContext: AgenticAiRuntimeContextType = {
  getAttachedFiles: () => [],
  loadSkill: () => {},
  getFrontendTool: () => undefined,
  getAllFrontendTools: () => [],
  getAllContexts: () => ({}),
  getToolEntityIds: () => [],
  getAllLiquidFields: () => [],
  clearSupportEntryPoint: () => {},
  clearPendingExistingChatResponse: () => {},
  clearPendingBrandGuidelineContexts: () => {},
};

export const AgenticAiRuntimeContext = createContext<AgenticAiRuntimeContextType>(initialAgenticAiRuntimeContext);
